import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const sampleRefundRequests = [
  {
    id: 1,
    orderType: "One-time",
    previousOrderStatus: "ordered",
    requestedNewStatus: "Refunded",
    cashRefundAmount: 1,
    bbCoinsAmount: 1,
    userId: 145,
    orderAmountPaid: 10,
    createdAt: "2026-08-14T01:36:55.52065",
    approvalStatus: "pending",
    orderDetails: {
      id: 112,
      publicId: "821136802",
      restaurantName: "Test",
      startTime: "13:00:00",
      endTime: "14:00:00",
      orderStatus: "payment_cancelled",
      nonDiscountedPrice: 8,
      price: 10,
      paymentmethod: "Razorpay",
      orderItems: [
        {
          id: 144,
          count: 1,
          name: "Shamg",
          price: 8,
          description: "tghb akok akok akok testQwertyyuuu",
        },
      ],
      userdetails: { number: "9879871234", name: "Joe" },
      riderDetails: { number: "Not Assigned", name: "Not Assigned" },
      orderdate: "2026-08-09",
    },
  },
  {
    id: 2,
    orderType: "One-time",
    previousOrderStatus: "Rider is assigned",
    requestedNewStatus: "Refunded",
    cashRefundAmount: 0,
    bbCoinsAmount: 0,
    userId: 145,
    orderAmountPaid: 165,
    createdAt: "2026-08-14T02:08:43.459348",
    approvalStatus: "pending",
    orderDetails: {
      id: 108,
      publicId: "652302608",
      restaurantName: "Thali Dakiya",
      startTime: "13:00:00",
      endTime: "14:00:00",
      orderStatus: "Rider is assigned",
      nonDiscountedPrice: 165,
      price: 165,
      paymentmethod: "Razorpay",
      orderItems: [
        {
          id: 140,
          count: 1,
          name: "Dakiya Executive Thali -1 (DET-1)",
          price: 165,
          description: null,
        },
      ],
      userdetails: { number: "9879871234", name: "Joe" },
      riderDetails: { number: "Not Assigned", name: "Not Assigned" },
      orderdate: "2026-08-06",
    },
  },
];

const getBadgeClass = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (normalized === "approved" || normalized === "refunded") return "bg-green-100 text-green-700 border-green-200";
  if (normalized === "pending") return "bg-yellow-100 text-yellow-700 border-yellow-200";
  if (normalized === "rejected") return "bg-red-100 text-red-700 border-red-200";
  return "bg-gray-100 text-gray-700 border-gray-200";
};

const formatDate = (value) => {
  if (!value) return "-";
  try {
    return new Date(value).toLocaleString();
  } catch (error) {
    return value;
  }
};

const DetailItem = ({ label, value }) => (
  <div className="rounded-lg border border-gray-200 bg-white p-2.5 shadow-sm">
    <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">{label}</div>
    <div className="mt-1 break-words text-sm font-medium text-gray-800">{value ?? "-"}</div>
  </div>
);

const Index = () => {
  const [refundRequests, setRefundRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const rawRole = localStorage.getItem("bentoAdminDetails");
    if (!rawRole) {
      setIsAdmin(false);
      return;
    }

    try {
      const parsedRole = JSON.parse(rawRole);
      const roleValue = Number(parsedRole ?? rawRole);
      const normalized = String(parsedRole ?? rawRole).trim().toLowerCase();
      setIsAdmin(!Number.isNaN(roleValue) ? roleValue === 4 : normalized === "admin");
    } catch (error) {
      const roleValue = Number(rawRole);
      const normalized = String(rawRole).trim().toLowerCase();
      setIsAdmin(!Number.isNaN(roleValue) ? roleValue === 4 : normalized === "admin");
    }
  }, []);

  const handleApproveRefund = async (request) => {
    const orderId = request?.orderDetails?.id ?? request?.id;
    if (!orderId) {
      alert("Order ID is missing for this refund request");
      return;
    }

    try {
      const payload = {
        coins: Number(request?.bbCoinsAmount || 0),
        cash: Number(request?.cashRefundAmount || 0),
      };

      await apiClient.put(`/updateOrderStatus/${orderId}/Refunded`, payload);

      setRefundRequests((prev) =>
        prev.map((item) =>
          item.id === request.id
            ? { ...item, approvalStatus: "approved" }
            : item
        )
      );
      alert("Refund request approved successfully");
    } catch (error) {
      console.error("Approve refund failed", error);
      alert(error?.response?.data?.message || "Failed to approve refund request");
    }
  };

  useEffect(() => {
    const fetchRefundRequests = async () => {
      try {
        const response = await apiClient.get("/refundRequest");
        const data = response?.data;
        setRefundRequests(Array.isArray(data) && data.length ? data : sampleRefundRequests);
      } catch (error) {
        console.error("Failed to fetch refund requests", error);
        setRefundRequests(sampleRefundRequests);
      } finally {
        setLoading(false);
      }
    };

    fetchRefundRequests();
  }, []);

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-500">Operations</p>
          <h1 className="text-2xl font-bold text-gray-900">Refund Requests</h1>
        </div>
        <div className="rounded-full border border-orange-200 bg-orange-50 px-3 py-1 text-sm font-medium text-orange-700">
          {refundRequests.length} total requests
        </div>
      </div>

      {loading ? (
        <div className="rounded-xl border border-gray-200 bg-white p-6 text-sm text-gray-600 shadow-sm">
          Loading refund requests...
        </div>
      ) : (
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse text-left text-sm text-gray-700">
              <thead className="bg-gray-900 text-white">
                <tr>
                  <th className="px-4 py-3 font-semibold">ID</th>
                  <th className="px-4 py-3 font-semibold">Order</th>
                  <th className="px-4 py-3 font-semibold">User</th>
                  <th className="px-4 py-3 font-semibold">Previous Status</th>
                  <th className="px-4 py-3 font-semibold">Requested</th>
                  <th className="px-4 py-3 font-semibold">Refund</th>
                  <th className="px-4 py-3 font-semibold">Amount Paid</th>
                  <th className="px-4 py-3 font-semibold">Created</th>
                  <th className="px-4 py-3 font-semibold">Approval</th>
                </tr>
              </thead>
              <tbody>
                {refundRequests.map((request) => {
                  const order = request.orderDetails || {};
                  const orderId = order.id ?? request.id;
                  const isExpanded = expandedId === orderId;

                  return (
                    <React.Fragment key={request.id}>
                      <tr className="border-t border-gray-200 align-top hover:bg-gray-50">
                        <td className="px-4 py-3 font-medium text-gray-900">#{request.id}</td>
                        <td className="px-4 py-3">
                          <div className="font-medium text-gray-800">{request.orderType}</div>
                          <button
                            type="button"
                            onClick={() => setExpandedId(isExpanded ? null : orderId)}
                            className="mt-1 inline-flex items-center text-left text-xs font-semibold text-blue-700 underline-offset-2 hover:underline"
                          >
                            Order ID: #{orderId}
                          </button>
                          <div className="text-xs text-gray-500">Public ID: #{order.publicId || "-"}</div>
                          <div className="text-xs text-gray-500">{order.restaurantName || "-"}</div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="font-medium text-gray-800">{order.userdetails?.name || "-"}</div>
                          <div className="text-xs text-gray-500">{request.userId || order.userdetails?.number || "-"}</div>
                        </td>
                        <td className="px-4 py-3">
                          <span className="rounded-full border bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                            {request.previousOrderStatus || "-"}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${getBadgeClass(request.requestedNewStatus)}`}>
                            {request.requestedNewStatus || "-"}
                          </span>
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="text-xs text-gray-500">Cash</div>
                          <div className="font-medium text-gray-800">₹{request.cashRefundAmount ?? 0}</div>
                          <div className="mt-1 text-xs text-gray-500">BB Coins</div>
                          <div className="font-medium text-gray-800">{request.bbCoinsAmount ?? 0}</div>
                        </td>
                        <td className="px-4 py-3 font-medium text-gray-800">₹{request.orderAmountPaid ?? 0}</td>
                        <td className="px-4 py-3 text-xs text-gray-600">{formatDate(request.createdAt)}</td>
                        <td className="px-4 py-3">
                          <span className={`rounded-full border px-2 py-1 text-xs font-semibold ${getBadgeClass(request.approvalStatus)}`}>
                            {request.approvalStatus || "-"}
                          </span>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr>
                          <td colSpan={9} className="bg-gray-50 px-4 py-4">
                            <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                              <div className="mb-3 flex items-center justify-between gap-3">
                                <h2 className="text-base font-bold text-gray-900">Order Details</h2>
                                <div className="flex items-center gap-2">
                                  <span className="rounded-full bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700">
                                    {order.orderStatus || "-"}
                                  </span>
                                  {isAdmin && request.approvalStatus !== "approved" && (
                                    <button
                                      type="button"
                                      onClick={() => handleApproveRefund(request)}
                                      className="rounded-lg bg-green-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition hover:bg-green-700"
                                    >
                                      Approve
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                                <DetailItem label="Order ID" value={request.id} />
                                <DetailItem label="Public ID" value={order.publicId} />
                                <DetailItem label="Chef ID" value={order.chefid} />
                                <DetailItem label="Start Time" value={order.startTime} />
                                <DetailItem label="End Time" value={order.endTime} />
                                <DetailItem label="Delivery Instruction" value={order.deliveryInstruction || "no data"} />
                                <DetailItem label="OTP" value={order.otp} />
                                <DetailItem label="Non Discounted Price" value={order.nonDiscountedPrice} />
                                <DetailItem label="Price" value={order.price} />
                                <DetailItem label="Coins Used" value={order.coinsused} />
                                <DetailItem label="Discount Value" value={order.discountvalue} />
                                <DetailItem label="Order Status" value={order.orderStatus} />
                                <DetailItem label="Customer Number" value={order.number} />
                                <DetailItem label="Customer Name" value={order.userdetails?.name} />
                                <DetailItem label="Restaurant Name" value={order.restaurantName} />
                                <DetailItem label="Order Date" value={order.orderdate} />
                                <DetailItem label="Street" value={order.street} />
                                <DetailItem label="City" value={order.city} />
                                <DetailItem label="Latitude" value={order.latitude} />
                                <DetailItem label="Longitude" value={order.longitude} />
                                <DetailItem label="Rider Name" value={order.riderDetails?.name} />
                                <DetailItem label="Rider Number" value={order.riderDetails?.number} />
                                <DetailItem label="Created At" value={order.createdAt} />
                                <DetailItem label="Updated At" value={order.updatedAt} />
                              </div>

                              <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-3">
                                <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">Order Items</div>
                                <div className="space-y-2">
                                  {(order.orderItems || []).map((item, index) => (
                                    <div key={`${item.id || index}`} className="grid grid-cols-1 gap-2 rounded-lg border border-gray-200 bg-white p-3 md:grid-cols-4">
                                      <div>
                                        <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Name</div>
                                        <div className="text-sm text-gray-800">{item.name || "-"}</div>
                                      </div>
                                      <div>
                                        <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Count</div>
                                        <div className="text-sm text-gray-800">{item.count ?? "-"}</div>
                                      </div>
                                      <div>
                                        <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Price</div>
                                        <div className="text-sm text-gray-800">{item.price ?? "-"}</div>
                                      </div>
                                      <div>
                                        <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Description</div>
                                        <div className="text-sm text-gray-800">{item.description || "no data"}</div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
